import { TabAddress } from 'components/user/user-detail/tab-address/TabAddress'
import { useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { capitalize, convertErrorMessage } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { EDIT_ADDRESS_VALIDATION } from 'services/validation/userValidation'
import { useBiteship } from 'services/useBiteship'
import { API } from 'services/api'
import { METHOD } from 'services/method'
import { Alert } from 'avo-ui'

const FIELD_NAME_DETAIL = {
    type: 'Nama alamat',
    name: 'Nama penerima',
    phone_number: 'Nomor handphone',
    detail_address: 'Kota & Kecamatan',
    zipcode: 'Kode pos',
    address: 'Alamat lengkap',
    note: 'Catatan',
    is_main_address: 'Jadikan alamat utama',
}

export const TabAddressContainer = ({ id }) => {
    const [modalEdit, setModalEdit] = useState(false)
    const [formValue, setFormValue] = useState({})
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm, clearErrorForm } = useValidation({
        form: formValue,
        schema: EDIT_ADDRESS_VALIDATION,
    })
    const [addressOptions, setAddressOptions] = useState({ address: [], zipcode: [] })
    const {
        data: addressList,
        fetching: getAddressListApi,
        isLoading: isLoadingList,
    } = useFetch(
        {
            ...API_USER.ADDRESS,
            initPathVariable: id,
        },
        {},
        { isFetching: true },
    )
    const { fetching: updateAddressApi, isLoading } = useFetch({ ...API_USER.ADDRESS, method: METHOD.PUT })
    const { fetching: searchArea } = useBiteship(API.BITESHIP_SEARCH_AREA)

    const onShowModalEdit = (item) => {
        setModalEdit(true)
        const { district, city, province, biteship_area_id } = item
        const newData = {
            type: { label: capitalize(item?.type), value: item?.type },
            detail_address: { label: `${district}, ${city}, ${province}`, value: biteship_area_id },
            zipcode: { label: item?.zipcode, value: item?.zipcode },
            phone_number: item?.phone_number?.startsWith('62') ? item?.phone_number?.substring(2) : item?.phone_number,
        }
        setFormValue({ ...item, ...newData })
    }

    const onChangeForm = (e) => {
        const { name, value, checked } = e
        const newData = { [name]: checked === undefined ? value : checked }
        if (name === 'detail_address') searchPostalCode(value.value)
        setFormValue({ ...formValue, ...newData })
    }

    const onHide = () => {
        setAddressOptions({ address: [], zipcode: [] })
        setModalEdit(false)
        clearErrorForm()
        setErrorMessage({})
    }

    const onSearchAddress = (keyword) => {
        const payload = {
            countries: 'ID',
            input: keyword,
            type: 'double',
        }

        searchArea(payload).then((item) => {
            const area = item.areas.map((address) => ({
                ...address,
                label: address.name,
                value: address.id,
            }))
            setAddressOptions({ address: area, zipcode: [] })
            setFormValue({ ...formValue, zipcode: null })
        })
    }

    const searchPostalCode = (areaId) => {
        searchArea({}, areaId).then((item) => {
            const zipcode = item.areas.map((zc) => ({
                label: zc.postal_code,
                value: zc.postal_code,
            }))
            setAddressOptions({ ...addressOptions, zipcode })
        })
    }

    const onSubmit = async () => {
        setErrorMessage({})
        validateForm().then(() => {
            updateAddress()
        })
    }

    const updateAddress = () => {
        let payload = {
            ...formValue,
            phone_number: `62${formValue?.phone_number}`,
            biteship_area_id: formValue?.detail_address?.value,
            type: formValue?.type.value || formValue.type,
            district: formValue?.detail_address?.administrative_division_level_3_name || formValue?.district,
            city: formValue?.detail_address?.administrative_division_level_2_name || formValue?.city,
            province: formValue?.detail_address?.administrative_division_level_1_name || formValue?.province,
            zipcode: formValue.zipcode?.value.toString(),
        }
        updateAddressApi(payload, formValue?.id)
            .then(() => {
                getAddressListApi()
                onHide()
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Address Updated !',
                })
            })
            .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
    }

    const props = {
        dataAddress: addressList?.data,
        modalEdit,
        onShowModalEdit,
        onHide,
        formValue,
        addressOptions,
        onChangeForm,
        onSearchAddress,
        errorForm: { ...errorForm, ...errorMessage },
        isLoading,
        isLoadingList,
        onSubmit,
    }

    return <TabAddress {...props} />
}
